import httpAuth from "../../services/httpAuth";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import { getCasinoLiveError, getCasinoLiveSuccess } from "./casinoLive.slice";
import { OPERATORID, USERID } from "../../config/app.config";

export const requestCasinoStart = (gameId = "", tableId = "") => async (
  dispatch,
  getState
) => {
  // const user = getState().auth;
  // console.log("User during live: ", user);

  try {
    const checkAuth = getState().auth;
    if (checkAuth) {
      if (gameId === "98789") {
        const response = await httpAuth.post(`/lotus/lobbyUrl`);
        if (response.data.status) {
          dispatch(getCasinoLiveSuccess({ url: response.data?.launchUrl }));
        }
        return response;
      } else if (gameId === "70011") {
        const userId = localStorage.getItem(USERID);
        const operatorId = localStorage.getItem(OPERATORID);
        let url = `https://games.fawk.app/${userId}/${operatorId}/${gameId}`;

        let data = {
          url: url,
          status: true,
          msg: "Play Game.",
        };
        dispatch(getCasinoLiveSuccess({ url: url }));
        return { data };
      }
      const response = await httpAuth.post("qtech/launchUrl", {
        gameId: gameId,
        providerCode: tableId,
      });

      // console.log("casino Res: ", response);
      if (response?.status == 200) {
        if (response?.data?.status) {
          dispatch(getCasinoLiveSuccess(response?.data?.data));
        } else {
          dispatch(getCasinoLiveError());
        }
      } else {
        dispatch(getCasinoLiveError());
      }
      return response;
    } else {
    }
  } catch (e) {
    dispatch(getCasinoLiveError());
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }

  // try {
  //   const checkAuth = getState().auth
  //   if ((id === "67722-1" || id === "67722-2") && !checkAuth) {
  //     dispatch(getCasinoLiveSuccess({
  //       "url": "https://games.fawk.app/" + makeId(10) + "/6666",
  //       "frame_key": "",
  //       "marketId": "7.7",
  //       "status": "OPEN"
  //     }));
  //   } else {
  //     const response = await httpAuth.post(`/casino/live/session/open`, { id, type })
  //     if (response.data.success) {
  //       dispatch(getCasinoLiveSuccess(response.data.result))
  //     }
  //     return response
  //   }

  // } catch (e) {
  //   dispatch(getCasinoLiveError())
  //   // const errorMsg = getErrorMessage(e)
  //   // throw errorMsg
  // }
};

function makeId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const requestCasinoEnd = () => async (dispatch) => {
  dispatch(getCasinoLiveSuccess(null));

  // try {
  //   const response = await httpAuth.post(`/casino/live/session/close`)
  //   if (response.data.success) {
  //     dispatch(getCasinoLiveSuccess(response.data.result))
  //   }
  //   return response
  // } catch (e) {
  //   dispatch(getCasinoLiveError())
  //   // const errorMsg = getErrorMessage(e)
  //   // throw errorMsg
  // }
};
